module.exports = __webpack_public_path__ + "static/media/notification.83307497.svg";